import * as React from 'react';

function SvgClickout(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <path
        d="M19.778 19.778H4.222V4.222h6.667a1.11 1.11 0 100-2.222H4.222C2.99 2 2 3 2 4.222v15.556C2 21 2.989 22 4.222 22h15.556C21 22 22 21 22 19.778V13.11a1.11 1.11 0 10-2.222 0v6.667zM14.222 3.11c0 .614.498 1.111 1.111 1.111h2.878L8.072 14.362a1.108 1.108 0 001.567 1.566l10.139-10.14v2.879a1.11 1.11 0 002.222 0V4a2 2 0 00-2-2h-4.667a1.11 1.11 0 00-1.11 1.111z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgClickout;
